module.exports = __webpack_public_path__ + "static/media/pc-teams-background-pattern-1.83def99d.svg";